import { Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { BalanceService, CategoriesService } from 'core';
import { AlertComponent } from 'shared/components/alert/alert.component';
import { AuthService } from 'core/services/auth.service';

@Component({
  selector: 'app-rewards',
  imports: [RouterLink, RouterOutlet, TranslatePipe, AlertComponent],
  templateUrl: './rewards.component.html',
  styleUrl: './rewards.component.scss'
})
export class RewardsComponent implements OnInit {
  readonly #balanceService = inject(BalanceService);
  readonly #authService = inject(AuthService);
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);
  readonly #categoriesService = inject(CategoriesService);
  readonly #destroyRef = inject(DestroyRef);

  get currentRoute() {
    return this.#router.url;
  }

  readonly availableGanas = this.#balanceService.balanceGanas;
  readonly showPromotionsBanner = computed(() => this.#authService.currentUser$()?.isSpecial === false);
  readonly redemptionsPaused = this.#categoriesService.redemptionsPaused;

  ngOnInit(): void {
    this.#categoriesService.loadRedemptionsStatus().pipe(takeUntilDestroyed(this.#destroyRef)).subscribe();
  }

  get selectedTabId() {
    return this.tabs().find(tab => {
      return tab.route === this.currentRoute.split('/')[3];
    })?.id;
  }

  readonly tabs = signal([
    { id: 0, title: 'rewards.forYou', route: 'for-you' },
    { id: 1, title: 'rewards.favorites', route: 'favorites' },
    { id: 2, title: 'rewards.explore', route: 'explore' }
  ]);

  onSelectTab(route: string) {
    this.#router.navigate([route], { relativeTo: this.#activatedRoute.parent });
  }
}
